<template>
  <div>
    <el-select
      class="w-100"
      :value="value[0].timezone"
      filterable
      remote
      reserve-keyword
      placeholder="Search timezones"
      :remote-method="remoteMethod"
      :loading="loading"
      @change="setValue">
      <el-option
        v-for="value in timezones"
        :key="value"
        :label="value"
        :value="value">
      </el-option>
    </el-select>

    <div ref="container"></div>

    <!-- <pre>{{timezones}}</pre> -->
  </div>
</template>

<script>
import * as $ from "jquery";
import "./TimezonePicker.js";

let $tzp = null;

export default {
  props: {
    value: {},
    options: {},
  },
  data() {
    return {
      loading: false,
      timezones: []
    }
  },
  /* watch: {
    value: (newValue, oldValue) => {
      // Careful: This results in inifite loop!
    }
  }, */
  mounted() {
    $tzp = $(this.$refs.container).timezonePicker(this.options);
    let vm = this;

    $tzp.on("map:value:changed", function () {

      let inputValue = $(this).data("timezonePicker").getValue();
      if ( !inputValue || (inputValue.length && inputValue.length !== 0)) {
        vm.$emit( "input", inputValue );
      }

      // vm.timezones = [ inputValue[0].timezone ];
    });

    if (this.value) {
      $tzp.data("timezonePicker").setValue(this.value);
    }

    this.timezones = [ this.value.timezone ];

  },
  methods: {
    setValue(value) {
      $tzp.data("timezonePicker").setValue(value);
    },

    remoteMethod(query) {
      if (query === '') {
        // let selected = { value: this.value.timezone };
        this.timezones = [ this.value.timezone ];
        return
      }
      this.loading = true;
      setTimeout(() => {

        let timezone_data = $tzp.data("timezonePicker").timezone;

        let timezones = timezone_data
          .filter(tz => {
            return tz.timezone.toLowerCase().indexOf(query.toLowerCase()) > -1;
          })
          .map(tz => {
            return tz.timezone;
          })

        let timezones_unique = timezones
          .filter((item, pos) => {
            return timezones.indexOf(item) === pos;
          })

        this.timezones = timezones_unique;
        this.loading = false;

      }, 10);
    }
  }
}
</script>
